import React, { Component } from "react";
import { Link } from "react-router-dom";
import Button from "../../FormElement/Button";
import { validForm } from "../../FormElement/FormValidator";
import InputFiled from "../../FormElement/InputFiled";


class ForgotPasswordForm extends Component {
  state = {
    userEmail: {
      email: ""
    },
    formErrors: {
      email: ""
    },
    isInvalid: true
  };

  handleChange = event => {
    const { name, value } = event.target;
    this.setState(
      prevState => {
        return {
          userEmail: {
            ...prevState.userEmail,
            [name]: value
          }
        };
      },
      () => {
        const { userEmail } = this.state;
        this.validateAll(userEmail);
      }
    );
  };

  handleError = (name, error) => {
    this.setState(
      prevState => {
        return {
          formErrors: {
            ...prevState.formErrors,
            [name]: error
          }
        };
      },
      () => {
        const { userEmail } = this.state;
        this.validateAll(userEmail);
      }
    );
  };

  validateAll = formFields => {
    this.setState({
      isInvalid: validForm(this.state.formErrors, formFields)
    });
  };

  handleSubmit = () => {
    const { userEmail } = this.state;
    this.props.handleSubmit(userEmail);
  };

  render() {
    const { userEmail, isInvalid } = this.state;
    return (
      <div className="">
        <div className="mainform">
          <p className="loginHeader">We'll send a recovery link to </p>

          <InputFiled
            value={userEmail.email}
            placeholder="example@mail.com"
            label="Email/Username"
            type="email"
            name="email"
            required
            validations={["email", "required"]}
            handleChange={this.handleChange}
            handleError={this.handleError}
          />

          <div
            className="signInSection"
            style={{
              display: "contents",
              alignItems: "baseline",
              justifyContent: "space-between"
            }}
          >
            <Link to="/login" style={{ color: "blue" }}>
              Return to login page
            </Link>
            <Button
              disabled={isInvalid}
              name="Send recovery link"
              styleClass="signIn"
              onclick={this.handleSubmit}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default ForgotPasswordForm;



// WEBPACK FOOTER //
// ./src/components/public/ForgotPassword/ForgotPasswordForm.js